import { useTranslation } from "react-i18next";

import useAppSelector from "hooks/store/useAppSelector";
import { selectHasSessionPromotion } from "store/slices/auth/selectors";

import { buildPathToStaticFolderOfCDN } from "utils/common";

import GradientButton from "components/ui/gradientButton/index.jsx";
import { setShowPromotionRulesAction } from "store/slices/promotion/actions.js";
import useAppDispatch from "hooks/store/useAppDispatch.js";

const Promotion = () => {
	const { t } = useTranslation();
	const hasPromotion = useAppSelector(selectHasSessionPromotion);
	const dispatch = useAppDispatch();

	return (
		hasPromotion && (
			<div className="vs--header-bonus promotion">
				<GradientButton
					onClick={() => dispatch(setShowPromotionRulesAction(true))}
					type="secondary"
					icon={
						<>
							<img src={buildPathToStaticFolderOfCDN("images/promotion/promotion-icon.gif")} alt="gift" />
							<span className="vs--header-bonus-text">Promotions</span>
						</>
					}
				>
					{t("common.promotions")}
				</GradientButton>
			</div>
		)
	);
};

export default Promotion;
